import React from 'react';
import styled from 'styled-components';
import WorkTagStation from './WorkTagStation';
import FilterStation from './FilterStation';
import WorkTopBar from '../work/WorkTopBar';


const WorkMetaStation: React.FC = () => {
  return (
    <WorkMetaStationContainer>
      <WorkTagStation />
      <RightMetaGroup>
        <FilterStation />
        <WorkTopBar />
      </RightMetaGroup>
    </WorkMetaStationContainer>
  );
}

export default WorkMetaStation;

const WorkMetaStationContainer = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  height: auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 6px 12px;
  padding-bottom: 4px;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};

  & > section {
    height: auto;
    min-width: 0;
  }

  & > section:first-of-type {
    flex: 1 1 auto;
    max-width: 100%;
    overflow: hidden;
  }
`;

const RightMetaGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-left: auto;
`;
